const services = [
  {
    id: 'boarding',
    title: 'DOG BOARDING',
    name: 'Dog Boarding',
    tagline: 'This Is Not Dog Boarding. This Is Dog Living.',
    description: `This Is Not Dog Boarding. This Is Dog Living.\n\nWhat Your Dog Gets:\n• Pack-based social life\n• Structured daily routine\n• Private sleeping suites\n• Temperature control\n• 24×7 supervision\n• Daily media updates`,
    bullets: [
      'Pack-based social life',
      'Structured daily routine',
      'Private sleeping suites',
      'Temperature control',
      '24×7 supervision',
      'Daily media updates',
    ],
    pricing: { basePrice: 800, currency: 'INR', duration: 1 },
    durationType: 'daily',
    type: 'boarding',
    meta: 'Pricing: Based on dog size & stay duration',
  },
  {
    id: 'daycare',
    title: 'DOG DAYCARE',
    name: 'Dog Daycare',
    tagline: 'Because Staying Home Alone Is Boring.',
    description: `Because Staying Home Alone Is Boring.\n\nBenefits:\n• Reduces anxiety\n• Improves behaviour\n• Burns energy\n\nProcess:\nMorning Drop • Pack Play • Rest & Recovery • Evening Pickup`,
    bullets: ['Reduces anxiety', 'Improves behaviour', 'Burns energy'],
    pricing: { basePrice: 500, currency: 'INR', duration: 1 },
    durationType: 'daily',
    type: 'day_care',
    meta: 'Daily / Weekly / Monthly packages available',
  },
  {
    id: 'grooming',
    title: 'DOG GROOMING',
    name: 'Dog Grooming',
    tagline: 'Grooming Dogs. Not Rushing Them.',
    description: `Grooming Dogs. Not Rushing Them.\n\nIncludes:\n• Bath\n• Nail trim\n• Ear cleaning\n• Coat care\n\nProcess:\nConsultation • Grooming • Recovery & Relaxation`,
    bullets: ['Bath', 'Nail trim', 'Ear cleaning', 'Coat care'],
    pricing: { basePrice: 600, currency: 'INR', duration: 90 },
    durationType: 'one_time',
    type: 'grooming',
    meta: 'Pricing based on breed & coat type',
  },
  {
    id: 'training',
    title: 'DOG TRAINING',
    name: 'Dog Training',
    tagline: 'Training That Dogs Understand',
    description: `Training That Dogs Understand.\n\nTraining Covers:\n• Obedience\n• Behaviour correction\n• Social confidence\n\nTraining Types:\n• Boarding Training\n• Private Sessions`,
    bullets: ['Obedience', 'Behaviour correction', 'Social confidence'],
    pricing: { basePrice: 1000, currency: 'INR', duration: 60 },
    durationType: 'one_time',
    type: 'training',
    meta: 'Options: Boarding training & private sessions',
  },
  {
    id: 'swimming',
    title: 'DOG SWIMMING',
    name: 'Dog Swimming',
    tagline: 'Their Favourite Workout.',
    description: `Their Favourite Workout.\n\nSwimming improves:\n• Fitness\n• Joint health\n• Confidence\n\nProcess:\nIntroduction • Supervised swim • Recovery`,
    bullets: ['Fitness', 'Joint health', 'Confidence'],
    pricing: { basePrice: 400, currency: 'INR', duration: 45 },
    durationType: 'one_time',
    type: 'swimming',
    meta: 'Clean pool, blow dry, supervision',
  },
];

export default services;
